var map = {
	"./image-cards.de-CH.json": 1232,
	"./image-cards.de-DE.json": 1233,
	"./image-cards.en-CA.json": 1234,
	"./image-cards.en-GB.json": 1235,
	"./image-cards.en-IN.json": 1236,
	"./image-cards.en-ME.json": 1237,
	"./image-cards.en-US.json": 1238,
	"./image-cards.es-EM.json": 1239,
	"./image-cards.es-ES.json": 1240,
	"./image-cards.fr-BE.json": 1241,
	"./image-cards.fr-CA.json": 1242,
	"./image-cards.fr-CH.json": 1243,
	"./image-cards.nl-BE.json": 1244,
	"./image-cards.nl-NL.json": 1245,
	"./image-cards.pl-PL.json": 1246,
	"./image-cards.pt-BR.json": 1247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1231;